import { useQueryClient } from '@tanstack/react-query'

import { apiPost } from '../axios.config'
import { API_ROUTES } from '../routes'
import { useMutationHook } from './mutationHook'

interface ICreateProductResponse {
  message: string
  data: string
}

interface ICreateProductParams {
  name: string
  productTypeId: string
  publicationGroupId: string
  legalId: string
  site: string
}

export async function fetchCreateProduct(path: string, body: ICreateProductParams) {
  const { data } = await apiPost<ICreateProductParams, ICreateProductResponse>({ path, body })

  return data
}

export const useCreateProduct = (options?: {
  onSuccess?: (data: ICreateProductResponse) => void
  onError?: (error: Error) => void
}) => {
  const queryClient = useQueryClient()
  const path = API_ROUTES.PRODUCT_CREATE
  const mutationFn = (url: string, body: ICreateProductParams) => fetchCreateProduct(url, body)

  const mutationFunc = useMutationHook({
    path,
    mutationKey: [path],
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.PRODUCTS],
      })
      options?.onSuccess?.(data)
    },
    onError: options?.onError,
  })

  return mutationFunc
}
